// src/pages/ContactPage.jsx
import React from 'react';
import ContactForm from '../components/ContactForm'; // Adjust path if needed
import Footer from '../components/Footer'; // Adjust path if needed
import './ContactPage.css'; // We'll create this for page-specific layout

const ContactPage = () => {
  return (
    <>
      <div className="page-container contact-page-container">
        <header className="contact-page-header">
          <h1>Get in Touch</h1>
          <p>Whether you have a question, an idea, or want to explore ways to collaborate—we’d love to hear from you. Use the form below to reach the Nexed Insight team and we’ll respond as soon as possible.</p>
        </header>
        <ContactForm />
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;